/**
 * Utility Functions - Constants
 * 
 * Application-wide constants for consistent behavior.
 * 
 * NOTE: Animation-related constants are in @/lib/animations.
 * Import animation timing from there directly.
 */

/**
 * Breakpoints for responsive design (matches Tailwind defaults)
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

/**
 * Z-index layers for consistent stacking
 */
export const Z_INDEX = {
  base: 0,
  dropdown: 10,
  sticky: 20,
  fixed: 30,
  modalBackdrop: 40,
  modal: 50,
  popover: 60,
  tooltip: 70,
} as const;

/**
 * Common query keys for React Query
 */
export const QUERY_KEYS = {
  products: "products",
  product: "product",
  cart: "cart",
  downloadLink: "downloadLink",
} as const;

/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  cart: "shopify-cart",
  language: "fshn-language",
  theme: "fshn-theme",
} as const;
